import React, { useId } from 'react';

export const MmcLabel = ({ children, icon: Icon = null, className = '', htmlFor, ...props }) => (
    <label className={`mmc-label ${className}`} htmlFor={htmlFor} {...props}>
        {Icon && <Icon size={14} weight="bold" />}
        {children}
    </label>
);

export const MmcInput = ({
    label,
    icon: Icon = null,
    error,
    id,
    className = '',
    wrapperClassName = '',
    ...props
}) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const errorId = `${inputId}-error`;

    return (
        <div className={`mmc-input-wrapper ${wrapperClassName}`} style={{ position: 'relative' }}>
            {label && <MmcLabel icon={Icon} htmlFor={inputId}>{label}</MmcLabel>}
            <div style={{ position: 'relative', width: '100%' }}>
                {Icon && !label && (
                    <div style={{
                        position: 'absolute',
                        left: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        opacity: 0.3,
                        pointerEvents: 'none',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <Icon size={16} weight="bold" />
                    </div>
                )}
                <input
                    id={inputId}
                    className={`mmc-input ${className}`}
                    style={{
                        paddingLeft: (Icon && !label) ? '38px' : '14px',
                        width: '100%'
                    }}
                    aria-invalid={!!error}
                    aria-describedby={error ? errorId : undefined}
                    {...props}
                />
            </div>
            {error && (
                <span id={errorId} className="mmc-input-error" role="alert" style={{ fontSize: '0.65rem', color: '#ff4444', marginTop: '4px' }}>
                    {error}
                </span>
            )}
        </div>
    );
};

export const MmcTextArea = ({
    label,
    icon: Icon = null,
    error,
    id,
    className = '',
    wrapperClassName = '',
    ...props
}) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const errorId = `${inputId}-error`;

    return (
        <div className={`mmc-input-wrapper ${wrapperClassName}`}>
            {label && <MmcLabel icon={Icon} htmlFor={inputId}>{label}</MmcLabel>}
            <textarea
                id={inputId}
                className={`mmc-textarea ${className}`}
                aria-invalid={!!error}
                aria-describedby={error ? errorId : undefined}
                {...props}
            />
            {error && (
                <span id={errorId} className="mmc-input-error" role="alert" style={{ fontSize: '0.65rem', color: '#ff4444', marginTop: '4px' }}>
                    {error}
                </span>
            )}
        </div>
    );
};
